newEnd